import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-account",
  "use": "icon-account-usage",
  "viewBox": "0 0 12 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 12 10\" id=\"icon-account\">\n<path id=\"icon-account_Icon\" d=\"M6,6.8c-1.3,0-2.4-1-2.4-2.3S4.7,2.1,6,2.1s2.4,1,2.4,2.3S7.3,6.8,6,6.8 M0,5.8C0,7.5,0.7,8.9,1.9,10\n\tC2.6,8.5,4.2,7.5,6,7.5s3.4,1,4.1,2.5C11.3,8.9,12,7.5,12,5.8C12,2.6,9.3,0,6,0S0,2.6,0,5.8z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./assets/svg/account.svg
// module id = 94
// module chunks = 0 1 2